<div aria-labelledby="dropdownConfig">
  <div>
    <h4 [qcId]="'filter-window'" class="filter-title text-black">التصفية</h4>
    <form [formGroup]="filterForm">
      <div class="row align-items-baseline">
        <div class="col-md-6 fromDate">
          <label> تاريخ الامتياز</label>
          <ng-container *ngIf="!isHijriDate">
            <app-datepicker-gregorian
              [qcId]="'from-date'"
              [displayFooter]="true"
              (onDateSelect)="selectFranchiseStartDate($event)"
              #datePickerFromGregorian
              [placeHolder]="'من'"
            >
            </app-datepicker-gregorian>
          </ng-container>
          <ng-container *ngIf="isHijriDate">
            <app-datepicker-umalqura
              [qcId]="'from-date'"
              [placeHolder]="'من'"
              (onDateSelect)="selectFranchiseStartDate($event)"
              #datePickerFromHijri
            >
            </app-datepicker-umalqura>
          </ng-container>
        </div>
        <div class="col-md-6 toDate">
          <div
            class="custom-control custom-checkbox d-flex flex-row-reverse hijri"
          >
            <input
              class="custom-control-input"
              [ngModelOptions]="{ standalone: true }"
              type="checkbox"
              value=""
              [(ngModel)]="isHijriDate"
              id="hijriDate"
              [qcId]="'ishijriDate'"
            />
            <label class="custom-control-label" for="hijriDate">
              التاريخ الهجري
            </label>
          </div>
          <ng-container *ngIf="!isHijriDate">
            <app-datepicker-gregorian
              [qcId]="'to-date'"
              (onDateSelect)="selectFranchiseEndDate($event)"
              [placeHolder]="'الى'"
              [displayFooter]="false"
              #datePickerToGregorian
            >
            </app-datepicker-gregorian>
          </ng-container>
          <ng-container *ngIf="isHijriDate">
            <app-datepicker-umalqura
              [qcId]="'to-date'"
              (onDateSelect)="selectFranchiseEndDate($event)"
              [placeHolder]="'الى'"
              (onDateSelect)="selectFranchiseStartDate($event)"
              #datePickerToHijri
            >
            </app-datepicker-umalqura>
          </ng-container>
        </div>
        <div [qcId]="'error-date'" class="text-danger pl-3">
          {{ errorMessage }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="text"> منطقة ممارسة الامتياز </label>
            <ng-select
              [qcId]="'region-select'"
              width="100%"
              appSelectedValue
              [items]="regions"
              bindLabel="localizedString"
              bindValue="id"
              placeholder="اختر المنطقة.."
              formControlName="franchisRegion"
              [closeOnSelect]="false"
              (change)="regionChanged($event)"
              [multiple]="true"
            >
              <ng-template
                ng-option-tmp
                let-item="item"
                let-item$="item$"
                let-index="index"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    id="item-{{ index }}"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="item$.selected"
                  />
                  <label class="custom-control-label" for="item-{{ index }}">
                    {{ item.localizedString }}
                  </label>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="text"> مدينة ممارسة الامتياز </label>
            <ng-select
              [qcId]="'city-select'"
              width="100%"
              appSelectedValue
              [items]="cities"
              bindLabel="localizedString"
              bindValue="id"
              placeholder="اختر المدينة.."
              formControlName="franchisCity"
              [closeOnSelect]="false"
              [multiple]="true"
            >
              <ng-template
                ng-option-tmp
                let-item="item"
                let-item$="item$"
                let-index="index"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    id="item-{{ index }}"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="item$.selected"
                  />
                  <label class="custom-control-label" for="item-{{ index }}">
                    {{ item.localizedString }}
                  </label>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="text"> اسم العلامة التجارية</label>
            <input
              [qcId]="'tradeMark-txt'"
              type="text"
              formControlName="tradeMarkName"
              class="form-control"
              placeholder="بحث باسم العلامة التجارية "
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group" formGroupName="grantMechanism">
            <label for="text"> الية المنح </label>
            <div class="custom-control custom-checkbox">
              <input
                [qcId]="'cr-check'"
                class="custom-control-input"
                formControlName="crDonor"
                (change)="ongrantMechanismChange($event)"
                type="checkbox"
                value="منح بالاسم التجاري"
                id="cr"
              />
              <label class="custom-control-label" for="cr">
                منح بالاسم التجاري
              </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input
                [qcId]="'tr-check'"
                class="custom-control-input"
                formControlName="trademarkDonor"
                type="checkbox"
                value="منح بالعلامة التجارية"
                (change)="ongrantMechanismChange($event)"
                id="cl"
              />
              <label class="custom-control-label" for="cl">
                منح بالعلامة التجارية
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group" formGroupName="franchiseType">
            <label for="text"> نوع الامتياز </label>
            <div class="custom-control custom-checkbox">
              <input
                [qcId]="'maincr-check'"
                class="custom-control-input"
                formControlName="MainCr"
                type="checkbox"
                value=""
                id="major"
              />
              <label class="custom-control-label" for="major">
                امتياز رئيسي
              </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input
                [qcId]="'minorcr-check'"
                class="custom-control-input"
                formControlName="MinorCr"
                type="checkbox"
                value=""
                id="mainor"
              />
              <label class="custom-control-label" for="mainor">
                امتياز فرعي
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown-footer d-flex justify-content-end">
        <button [qcId]="'reset-btn'" class="btn btn-outline-default" (click)="onResetFilter()">
          <i class="fa-solid fa-rotate-right"></i>
          <span> اعادة تعيين </span>
        </button>
        <button [qcId]="'submit-btn'" class="btn btn-green" (click)="onFilter()">
          تطبيق التصفية
        </button>
      </div>
    </form>
  </div>
</div>
